/**
 * Game preset types matching original Quadra
 * Reference: quadra/source/game.h:130-131
 */
export enum GamePreset {
  PRESET_SINGLE = "PRESET_SINGLE",
  PRESET_SINGLE_SPRINT = "PRESET_SINGLE_SPRINT",
}

/**
 * Game preset configuration
 * Reference: quadra/source/game.cc:66-110 (Game_params::set_preset)
 */
export interface GamePresetConfig {
  single: boolean;
  network: boolean;
  levelUp: boolean;
  gameEnd?: "END_TIME" | "END_FRAG" | "END_LINES";
  gameEndValue?: number;
}

/**
 * Apply game preset configuration
 * Matches quadra/source/game.cc:95-106
 */
export function applyGamePreset(preset: GamePreset): GamePresetConfig {
  switch (preset) {
    case GamePreset.PRESET_SINGLE:
      return {
        single: true,
        network: false,
        levelUp: true,
      };
    case GamePreset.PRESET_SINGLE_SPRINT:
      return {
        single: true,
        network: false,
        levelUp: true,
        gameEnd: "END_TIME",
        gameEndValue: 5, // 5 minutes
      };
    default:
      return {
        single: false,
        network: true,
        levelUp: false,
      };
  }
}

/**
 * Convert game type string to preset enum
 */
export function gameTypeToPreset(gameType: "normal" | "sprint"): GamePreset {
  return gameType === "sprint"
    ? GamePreset.PRESET_SINGLE_SPRINT
    : GamePreset.PRESET_SINGLE;
}

